import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_BALLAST_BRAND: 'LIST_BALLAST_BRAND',
  LIST_BALLAST_TYPE: 'LIST_BALLAST_TYPE',
};

export const listBallastBrand = () => ({
  type: ACTION.LIST_BALLAST_BRAND,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_BALLAST_BRAND,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});

export const listBallastType = () => ({
  type: ACTION.LIST_BALLAST_TYPE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_BALLAST_TYPE,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});


// WEBPACK FOOTER //
// ./src/redux/references/ballast_actions.js